<template>
  <div class="event-prices" v-if="!isMobileScreen && (eventIsNotEnded || awardIsNotEnded)">
    <h4 class="heading">
      EVENT PRICES
    </h4>
    <div
      class="event-prices-section"
      v-for="eventPrice in prices"
      :key="eventPrice.id"
    >
      <div>
        <p class="price-text">{{ eventPrice.name }}</p>
        <p class ="price" >{{ eventPrice.price }} {{ currencyCode }}</p>
      </div>
    </div>
    <button
      v-if="!isBooked && isEventHasBankAccount"
      class="eventBookButton"
      @click="openBookEvent()"
    >
      BOOK NOW
    </button>
  </div>
  <b-card v-else-if="isMobileScreen && (eventIsNotEnded || awardIsNotEnded)" no-body class="mb-1">
    <b-card-header v-b-toggle.event-prices header-tag="header" role="tab">
      <div class="text-center">
        EVENT PRICES
        <i class="fas fa-chevron-up" />
        <i class="fas fa-chevron-down" />
      </div>
    </b-card-header>
    <b-collapse id="event-prices" accordion="my-accordion" role="tabpanel">
      <b-card-body id="agenda-info-knowledge-sessions-container">
        <div
          class="event-prices-section"
          v-for="eventPrice in prices"
          :key="eventPrice.id"
        >
          <div>
            <p class="price-text">{{ eventPrice.name }}</p>
            <p class ="price" >{{ eventPrice.price }} {{ currencyCode }}</p>
          </div>
        </div>
      </b-card-body>
      <button
        v-if="!isBooked && isEventHasBankAccount"
        class="eventBookButton"
        @click="openBookEvent()"
      >BOOK NOW
    </button>
    </b-collapse>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import moment from 'moment';
import store from '../../store';
import getIDfromURL from '../../utils/getIDfromURL';
import { getOwnerId } from '../../utils/getOwnerId';


export default {
  name: 'EventPrices',
  data() {
    return {
      invoices: [],
      company: {},
      prices: [],
      isEventHasBankAccount: false,
      eventIsNotEnded: false,
      awardIsNotEnded: false,
      currencyCode: '',
      eventFinancialEntity: null,
    };
  },
  computed: {
    ...mapGetters({
      eventPrices: 'events/eventPrices',
      userInfo: 'user/fetchUserInfo',
      awardPrices: 'events/awardPrices',
      getEvent: 'events/fetchEvent',
      getAward: 'awards/award',
      participantMembers: 'events/participantMembers',
      isMobileScreen: 'isMobileScreen',
    }),
    isBooked() {
      const event = { ...this.getEvent, ...this.getAward };
      const { participant_customers, url } = event;
      let index;
      if (participant_customers) {
        index = participant_customers.findIndex(participant => participant.customer_id === this.userInfo.id);
        if (index !== -1) return true;
      }
      index = this.invoices.findIndex(invoice => invoice.event === url || invoice.award === url);
      return index !== -1;
    },
  },
  watch: {
    '$route.params': {
      handler() { this.bookButtonFunc(); },
      immediate: true,
    },
  },
  async mounted() {
    if (this.$lodash.isEmpty(this.userInfo)) await this.fetchUserInfo();
    this.bookButtonFunc();
    await this.fetchUserInvoices(getOwnerId()).then(
      ({ results }) => (this.invoices = results),
    );
  },
  methods: {
    ...mapActions({
      fetchAwardPrices: 'events/fetchAwardPrices',
      fetchEventPrices: 'events/fetchEventPrices',
      fetchEvent: 'events/fetchEvent',
      fetchAward: 'awards/fetchAward',
      fetchCompany: 'companies/fetchCompany',
      fetchPaymentEntities: 'companies/fetchPaymentEntities',
      fetchUserInvoices: 'user/fetchUserInvoices',
      fetchUserInfo: 'user/fetchUserInfo',

    }),
    async bookButtonFunc() {
      const { params } = this.$route;
      try {
        await this.fetchCompany(getIDfromURL(this.userInfo.company)).then(res => this.company = res);
        if (params.eventId) {
          await this.fetchEvent(params.eventId).then(({
            end_date, currency_code, financial_entity,
          }) => {
            this.currencyCode = currency_code;
            this.eventFinancialEntity = financial_entity;
            this.eventIsNotEnded = end_date > moment(new Date().toUTCString()).format('YYYY-MM-DD');
          });
          await this.fetchEventPrices(params.eventId).then(({ results }) => {
            this.prices = results.filter(price => price.price_type === this.company.category);
          });
        } else {
          await this.fetchAward(params.awardId).then(({
            currency_code, end_date, financial_entity,
          }) => {
            this.currencyCode = currency_code;
            this.eventFinancialEntity = financial_entity;
            this.awardIsNotEnded = end_date > moment(new Date().toUTCString()).format('YYYY-MM-DD');
          });
          await this.fetchAwardPrices(params.awardId).then(({ results }) => {
            this.prices = results.filter(price => price.price_type === this.company.category);
          });
        }
        await this.fetchPaymentEntities().then(({ results }) => {
          results.forEach((entity) => {
            if (entity.url && entity.url === this.eventFinancialEntity && entity.bank_accounts.length) {
              this.isEventHasBankAccount = true;
            }
          });
        });
      } catch (err) {
        console.log(err);
      }
    },

    async openBookEvent() {
      const config = {
        headers: { Authorization: `Bearer ${this.$store.getters['auth/access']}` },
      };
      if (this.$route.params.eventId && this.eventPrices[0]) {
        const { data: { id } } = await axios(this.eventPrices[0].event, config);
        this.$router.push({ name: 'BookEventDetails', params: { id } });
      } else if (this.awardPrices[0]) {
        const { data: { id } } = await axios(this.awardPrices[0].award, config);
        this.$router.push({ name: 'BookAwardDetails', params: { id } });
      }
    },
  },

};
</script>

<style scoped>
.event-prices {
  background-color: white;
  margin-bottom:  15px;
  border-radius: 0 10px 10px 10px;
}
.event-prices-section div {
  border-top: 1px solid #e1e1e1;
  padding: 14px 5px 14px 8px;
  text-align: center;
}
.event-prices-section div p{
  margin: 0;
}
.price-text {
  float: left;
  margin-left: 33px;
  text-transform: capitalize;
  font-size: 13px;
  color: #615f5f;
}
.price{
  font-size:12px;
  color: #615f5f;
  text-align: right;
  padding-right: 4px;

}
.eventBookButton{
  background-color: #BD9D5F;
  color: #fff;
  border: 1px solid #BD9D5F;
  width: 100%;
  text-align: center;
  height: 37px;
  margin: 1px 0 0;
  border-radius: 0 0 10px 10px;
}
.eventBookButton:hover{
  background-color: #fff;
  color: #BD9D5F;
}
.heading{
  margin: 13px 12px;
  padding-top: 15px;
  font-family: Montserrat;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: var(--text-grey);
}

@media (max-width: 1024px) {
  .card {
    border-radius: 0 10px 10px 10px !important;
    overflow: hidden;
  }
  .card>.card-header>div {
    font-size: 13px;
  }
  .card>.collapse>.card-body {
    padding: 0;
  }
  .card > header i {
    position: absolute;
    top: 16px;
    right: 20px;
  }
  header .fa-chevron-up {
    display: inline-block;
  }
  header .fa-chevron-down {
    display: none;
  }
  .card > .collapsed .fa-chevron-down {
    display: inline-block;
  }
  .card > .collapsed .fa-chevron-up {
    display: none;
  }
  .eventBookButton {
    color: #BD9D5F;
    background-color: #fff;
    border: unset;
    border-top: 2px solid #ebebeb;
    font-size: 12px;
  }
  .event-prices-section div p {
    font-size: 12px;
  }
}
</style>
